import { axios } from '@Root/API'

export const get = studyProgrammeId => {
	return axios.get(`students/show/course-session/${studyProgrammeId}`)
}
